import { FormControl } from "baseui/form-control";
import { Input } from "baseui/input";
import { useDebounce } from "use-debounce";
import { useState } from "react";

import { useFormContext } from "./FormContext";
import { useSkipFirstRunEffect } from "../../hooks/useSkipFirstRunEffect";

export const WeightField: React.FC = () => {
  const { order, update } = useFormContext();
  const [value, setValue] = useState<string | number>(() => order.weight ?? "");
  const [debouncedValue] = useDebounce(value, 1000);

  useSkipFirstRunEffect(() => {
    const weight = Number(debouncedValue);

    if (isNaN(weight)) return;

    console.log("Updating weight");

    update({
      variables: {
        data: { weight: { set: weight } },
        where: { id: order.id },
      },
      optimisticResponse: {
        order: {
          ...order,
          weight,
        },
      },
    });
  }, [debouncedValue]);

  return (
    <FormControl label="Peso">
      <Input
        inputMode="numeric"
        min={0}
        name="weight"
        onChange={(e) => setValue(e.currentTarget.value)}
        step={0.01}
        type="number"
        value={value}
      />
    </FormControl>
  );
};
